import { render, staticRenderFns } from "./bidcreate.vue?vue&type=template&id=2ef46ca2&"
import script from "./bidcreate.vue?vue&type=script&lang=js&"
export * from "./bidcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports